<template>
    <div class="container-fluid">
        <div class="row" v-if="user">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title float-left" v-if="user.id"> Изменить пользователь</h4>
                        <h4 class="card-title float-left" v-else> Добавить пользователь</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div class="form-group">
                                    <label for="firstName">Имя <span class="red">*</span></label>
                                    <input type="text" class="form-control" id="firstName" v-model="user.firstName"
                                        :class="{invalid : $v.user.firstName.$error}"
                                        @blur="$v.user.firstName.$touch()">
                                    <div class="red" v-if="$v.user.firstName.$error">Пожалуйста, введите имя</div>
                                </div>
                                <div class="form-group">
                                    <label for="lastName">Фамилия <span class="red">*</span></label>
                                    <input type="text" class="form-control" id="lastName" v-model="user.lastName"
                                        :class="{invalid : $v.user.lastName.$error}"
                                        @blur="$v.user.lastName.$touch()">
                                    <div class="red" v-if="$v.user.lastName.$error">Пожалуйста, введите фамилия</div>
                                </div>
                                <div class="form-group">
                                    <label for="email">E-Mail</label>
                                    <input type="text" class="form-control" id="email" v-model="user.email">
                                </div>
                                <div class="form-group">
                                    <label for="phone">Телефон</label>
                                    <the-mask type="text" class="form-control" v-model="user.phone" mask="+998 (##) ### ## ##"/>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div class="form-group">
                                    <label for="username">Логин <span class="red">*</span></label>
                                    <input type="text" class="form-control" id="username" v-model="user.username"
                                        :class="{invalid : $v.user.username.$error}"
                                        @blur="$v.user.username.$touch()">
                                    <div class="red" v-if="$v.user.username.$error">Пожалуйста, введите логин</div>
                                </div>
                                <div class="form-check" v-if="user.id">
                                    <label class="form-check-label pl-0">
                                        <input class="form-check-input" type="checkbox" v-model="user.changePassword">
                                        <span class="form-check-sign"></span>
                                        Изменить пароль
                                    </label>
                                </div>
                                <div class="form-group" v-if="!user.id || user.changePassword">
                                    <label for="password">Пароль <span class="red">*</span></label>
                                    <input type="text" class="form-control" id="password" v-model="user.password"
                                        :class="{invalid : $v.user.password.$error}"
                                        @blur="$v.user.password.$touch()">
                                    <div v-if="$v.user.password.$error">
                                        <div class="red" v-if="!$v.user.password.required">Пожалуйста, введите пароль</div>
                                        <div class="red" v-else-if="$v.user.password.$params && $v.user.password.$params.minLen && $v.user.password.$params.minLen.min">
                                            Пароль должен быть не менее {{$v.user.password.$params.minLen.min}} символов
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group" v-if="!user.id || user.changePassword">
                                    <label for="passwordConfirm">Подтверждение пароля <span class="red">*</span></label>
                                    <input type="text" class="form-control" id="passwordConfirm" v-model="user.passwordConfirm"
                                        :class="{invalid : $v.user.passwordConfirm.$error}"
                                        @blur="$v.user.passwordConfirm.$touch()">
                                    <div v-if="$v.user.passwordConfirm.$error">
                                        <div class="red" v-if="!$v.user.passwordConfirm.required">Пожалуйста, введите подтверждение пароля</div>
                                        <div class="red" v-else>
                                            Подтверждение пароля не должно быть менее {{$v.user.passwordConfirm.$params.minLen.min}} символов
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>Роль</label>
                                    <div class="form-check">
                                        <label class="form-check-label pl-0">
                                            <input class="form-check-input" type="checkbox" v-model="hasAdminRole">
                                            <span class="form-check-sign"></span>
                                            Администратор
                                        </label>
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="checkbox" v-model="hasDispatcherRole">
                                            <span class="form-check-sign"></span>
                                            Диспетчер
                                        </label>
                                    </div>
                                </div>
                                <div class="form-check">
                                    <label class="form-check-label pl-0">
                                        <input class="form-check-input" type="checkbox" v-model="user.activated">
                                        <span class="form-check-sign"></span>
                                        Активный
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-5">
                            <div class="col-md-12 text-center">
                                <button class="btn btn-default" @click="cancel" :disabled="processing">Отменить</button>
                                <button class="btn btn-success ml-3" @click="save" :disabled="processing">Сохранить</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {required, requiredUnless, minLength} from 'vuelidate/lib/validators';

    export default {
        name: "UserEdit",
        data() {
            return {
                processing: false,
                user: {
                    id: null,
                    username: '',
                    password: '',
                    passwordConfirm: '',
                    firstName: '',
                    lastName: '',
                    email: '',
                    phone: '',
                    roles: [],
                    activated: false,
                    changePassword: false
                },
                parents: []
            }
        },
        validations: {
            user: {
                username: {
                    required: required
                },
                firstName: {
                    required: required
                },
                lastName: {
                    required: required
                },
                password: {
                    required: requiredUnless(vm => {
                        return !(vm.changePassword || !vm.id);
                    }),
                    minLen: minLength(6)
                },
                passwordConfirm: {
                    required:  requiredUnless(vm => {
                        return !(vm.changePassword || !vm.id);
                    }),
                    minLen: minLength(6)
                }
            }
        },
        computed: {
            enablePassword() {
                return !this.user.id || this.user.changePassword;
            },
            hasAdminRole: {
                get: function() {
                    return this.user.roles && this.user.roles.indexOf('ROLE_ADMIN') >= 0;
                },
                set: function(value) {
                    this.changeRole('ROLE_ADMIN', value);
                }
            },
            hasDispatcherRole: {
                get: function() {
                    return this.user && this.user.roles && this.user.roles.indexOf('ROLE_DISPATCHER') >= 0;
                },
                set: function(value) {
                    this.changeRole('ROLE_DISPATCHER', value);
                }
            }
        },
        methods: {
            changeRole(role, value) {
                const index = this.user.roles.indexOf(role);
                if (value) {
                    if (index < 0) {
                        this.user.roles.push(role);
                    }
                } else {
                    if (index >= 0) {
                        this.user.roles.splice(index, 1);
                    }
                }
            },
            cancel() {
                this.$router.push('/user');
            },
            load(id) {
                this.$http.get('user/' + id)
                    .then(res => {
                        res = res.data;
                        this.user = res;
                    }, err => {
                        console.log(err);
                    });
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;
                this.$http.post('user', this.user)
                    .then(res => {
                        if (res.data && res.data.status === 'SUCCESS') {
                            this.$v.$reset();
                            this.$swal({
                                title: 'Информация',
                                text: 'Пользователь успешно сохранен',
                                type: 'info'
                            });
                            this.$router.push('/user');
                        } else if (res.data && res.data.message && res.data.message.length > 0){
                            this.$swal({
                                title: 'Предупреждение',
                                text: res.data.message,
                                type: 'warning'
                            });
                        } else {
                            this.$swal({
                                title: 'Ошибка',
                                text: 'Произошла ошибка',
                                type: 'error'
                            });
                        }
                        this.processing = false;
                    }, () => {
                        this.processing = false;
                        this.$swal({
                                title: 'Ошибка',
                                text: 'Произошла ошибка',
                                type: 'error'
                            });
                    });
            }
        },
        created() {
            const id = this.$route.params.id;
            if (id && id > 0) {
                this.load(id);
            }
        }
    }
</script>

<style scoped>

</style>